import {
	AnswerType,
	AnswerValue,
	CompanyBalance,
	CompanyRevenue,
	CompanySize,
	Industry,
} from "@/types/questionnaire";

import SelectIndustryStep from "./SelectIndustryStep";
import RadioOptionStep from "./RadioOptionStep";

interface BusinessInfoStepBodyProps {
	currentStepIndex: number;
	industries: Industry[];
	companySizes: CompanySize[];
	companyRevenues: CompanyRevenue[];
	companyBalances: CompanyBalance[];
	selectedIndustryIds: number[];
	setSelectedIndustryIds: (ids: number[]) => void;
	selectedCompanySizeId: number | null;
	setSelectedCompanySizeId: (id: number) => void;
	selectedCompanyRevenueId: number | null;
	setSelectedCompanyRevenueId: (id: number) => void;
	selectedCompanyBalanceId: number | null;
	setSelectedCompanyBalanceId: (id: number) => void;
	setAnswer: (a: AnswerType) => void;
}

export default function BusinessInfoStepBody({
	currentStepIndex,
	industries,
	companySizes,
	companyRevenues,
	companyBalances,
	selectedIndustryIds,
	setSelectedIndustryIds,
	selectedCompanySizeId,
	setSelectedCompanySizeId,
	selectedCompanyRevenueId,
	setSelectedCompanyRevenueId,
	selectedCompanyBalanceId,
	setSelectedCompanyBalanceId,
	setAnswer,
}: BusinessInfoStepBodyProps) {
	if (currentStepIndex === 0) {
		return (
			<SelectIndustryStep
				options={industries}
				value={selectedIndustryIds}
				onChange={(selectedIds) => {
					setSelectedIndustryIds(selectedIds);

					const selectedAnswerValues: AnswerValue[] = selectedIds
						.map((id) => industries.find((i) => i.id === id))
						.filter((industry): industry is Industry => industry !== undefined)
						.map((industry) => ({ id: industry.id, title: industry.name }));

					setAnswer({
						multiple: true,
						values: selectedAnswerValues,
					});
				}}
			/>
		);
	}

	if (currentStepIndex === 1) {
		return (
			<RadioOptionStep
				options={companySizes.filter((i): i is CompanySize => typeof i.id === "number")}
				value={selectedCompanySizeId}
				onChange={(selectedId) => {
					const selected = companySizes.find((s) => s.id === selectedId);

					if (!selected) {
						return;
					}

					setSelectedCompanySizeId(selected.id);
					setAnswer({
						values: [{ id: selected.id, title: selected.value }],
					});
				}}
			/>
		);
	}

	if (currentStepIndex === 2) {
		return (
			<RadioOptionStep
				options={companyRevenues.filter((i): i is CompanyRevenue => typeof i.id === "number")}
				value={selectedCompanyRevenueId}
				onChange={(selectedId) => {
					const selected = companyRevenues.find((r) => r.id === selectedId);

					if (!selected) {
						return;
					}

					setSelectedCompanyRevenueId(selected.id);
					setAnswer({
						values: [{ id: selected.id, title: selected.value }],
					});
				}}
			/>
		);
	}

	if (currentStepIndex === 3) {
		return (
			<RadioOptionStep
				options={companyBalances.filter((i): i is CompanyBalance => typeof i.id === "number")}
				value={selectedCompanyBalanceId}
				onChange={(selectedId) => {
					const selected = companyBalances.find((b) => b.id === selectedId);

					if (!selected) {
						return;
					}

					setSelectedCompanyBalanceId(selected.id);
					setAnswer({
						values: [{ id: selected.id, title: selected.value }],
					});
				}}
			/>
		);
	}

	return null;
}
